// import "./update.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { expenseInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const classOptions = [
//   { value: "IX", label: "IX" },
//   { value: "X", label: "X" },
//   { value: "XI", label: "XI" },
//   { value: "XII", label: "XII" },
// ];

// const ExpenseUpdate = ({ title }) => {
//   // Extracting expenseId using regular expressions
//   const location = useLocation();
//   const expenseId = location.pathname.match(/\/update-expense\/(\d+)/)?.[1];
//   const center_id = localStorage.getItem("center_id");
//   // Initializing state
//   // const [file, setFile] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedName, setSelectedName] = useState(null);
//   const [selectedUser, setSelectedUser] = useState([]);
//   const [useroptions, setUseroptions] = useState([]);
//   const [selectedTransaction, setSelectedTransaction] = useState([]);
//   const [transactionoptions, setTransactionoptions] = useState([]);
//   const [selectedAccount, setSelectedAccount] = useState([]);
//   const [accountoptions, setAccountoptions] = useState([]);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchExpense = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/expense/${expenseId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         const snames = data.data.user_names;
//         const sid = data.data.user_id;
//         // console.log("abbas1",abbas);
//         const namelist = [];
//         const name = snames;
//         console.log(name);
//         const id = sid; // Access the "name" property
//         namelist.push({ value: id, label: name });
//         const transaction = data.data.transaction_names;
//         const tid = data.data.transaction_id;
//         // console.log("abbas1",abbas);
//         const namelist_t = [];
//         namelist_t.push({ value: tid, label: transaction });
//         const account = data.data.account_names;
//         const aid = data.data.account_id;
//         // console.log("abbas1",abbas);
//         const namelist_a = [];
//         namelist_a.push({ value: aid, label: account });
//         const status = data.data.status;
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }
//         setSelectedUser(namelist);
//         setSelectedTransaction(namelist_t);
//         setSelectedAccount(namelist_a);
//         setInputValues(data.data);
//         // setFile(data.data.logo);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (expenseId) {
//       fetchExpense();
//     }
//   }, [expenseId]);
//   // console.log("quiz in a state:", data);

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setSelectedUser(selectedOption);
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     user_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUseroptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleTransactionSelectChange = (selectedOption) => {
//     setSelectedTransaction(selectedOption);
//     setInputValues({
//       ...inputValues,
//       transaction_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     transaction_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const transaction_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/transaction_ids`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].transaction_type;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setTransactionoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleAccountSelectChange = (selectedOption) => {
//     setSelectedAccount(selectedOption);
//     setInputValues({
//       ...inputValues,
//       account_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     account_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const account_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/account_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setAccountoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   console.log(selectedAccount);
//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("id", expenseId);
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("expense_id", inputValues.expense_id);
//     formData.append("transaction_id", inputValues.transaction_id);
//     formData.append("account_id", inputValues.account_id);
//     formData.append("amount", inputValues.amount);
//     formData.append("description", inputValues.description);
//     formData.append("user_id", inputValues.user_id);
//     formData.append("status", parseInt(inputValues.status));
//     console.log(formData);

//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_expense/${expenseId}`, {
//       method: "PUT",
//       body: formData, // Pass the object as the body
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Expense updated successfully!");
//           setTimeout(() => {
//             navigate("/expense");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         // file
//                                     }
//                                     alt=""
//                                     className="itemImg"
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {expenseInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "transaction_id" ? (
//                         <Select
//                           options={transactionoptions}
//                           name={input.fieldName}
//                           value={selectedTransaction}
//                           onChange={handleTransactionSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "user_id" ? (
//                         <Select
//                           options={useroptions}
//                           name={input.fieldName}
//                           value={selectedUser}
//                           onChange={handleUserSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "account_id" ? (
//                         <Select
//                           options={accountoptions}
//                           name={input.fieldName}
//                           value={selectedAccount}
//                           onChange={handleAccountSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/class/${expenseId}`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/expense`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default ExpenseUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { expenseInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const ExpenseUpdate = ({ title }) => {
  const location = useLocation();
  const expenseId = location.pathname.match(/\/update-expense\/(\d+)/)?.[1];
  const center_id = localStorage.getItem("center_id");
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedUser, setSelectedUser] = useState([]);
  const [useroptions, setUseroptions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState([]);
  const [transactionoptions, setTransactionoptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [accountoptions, setAccountoptions] = useState([]);
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchExpense = async () => {
      try {
        const response = await fetch(`${serverUrl}/expense/${expenseId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch expense data");
        }
        const data = await response.json();
        
        const userList = [{ value: data.data.user_id, label: data.data.user_names }];
        const transactionList = [{ value: data.data.transaction_id, label: data.data.transaction_names }];
        const accountList = [{ value: data.data.account_id, label: data.data.account_names }];
        
        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );
        setSelectedUser(userList);
        setSelectedTransaction(transactionList);
        setSelectedAccount(accountList);
        setInputValues(data.data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch expense data.");
      }
    };

    if (expenseId) {
      fetchExpense();
    }
  }, [expenseId]);

  useEffect(() => {
    user_name();
    transaction_name();
    account_name();
  }, []);

  const user_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch users");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setUseroptions(namelist);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch users data.");
    }
  };

  const transaction_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/transaction_ids`);
      if (!response.ok) {
        throw new Error("Failed to fetch transactions");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.transaction_type,
      }));
      setTransactionoptions(namelist);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      toast.error("Failed to fetch transactions data.");
    }
  };

  const account_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/account_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch accounts");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setAccountoptions(namelist);
    } catch (error) {
      console.error("Error fetching accounts:", error);
      toast.error("Failed to fetch accounts data.");
    }
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUserSelectChange = (selectedOption) => {
    setSelectedUser(selectedOption);
    setInputValues({
      ...inputValues,
      user_id: selectedOption.value,
    });
  };

  const handleTransactionSelectChange = (selectedOption) => {
    setSelectedTransaction(selectedOption);
    setInputValues({
      ...inputValues,
      transaction_id: selectedOption.value,
    });
  };

  const handleAccountSelectChange = (selectedOption) => {
    setSelectedAccount(selectedOption);
    setInputValues({
      ...inputValues,
      account_id: selectedOption.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    
    formData.append("id", expenseId);
    formData.append("center_id", center_id);
    formData.append("expense_id", inputValues.expense_id);
    formData.append("transaction_id", inputValues.transaction_id);
    formData.append("account_id", inputValues.account_id);
    formData.append("amount", inputValues.amount);
    formData.append("description", inputValues.description);
    formData.append("user_id", inputValues.user_id);
    formData.append("status", parseInt(inputValues.status));

    try {
      const response = await fetch(`${serverUrl}/upd_expense/${expenseId}`, {
        method: "PUT",
        body: formData,
      });
      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Expense updated successfully!");
        setTimeout(() => {
          navigate("/expense");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {expenseInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "transaction_id" ? (
                              <Select
                                options={transactionoptions}
                                value={selectedTransaction}
                                onChange={handleTransactionSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "user_id" ? (
                              <Select
                                options={useroptions}
                                value={selectedUser}
                                onChange={handleUserSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "account_id" ? (
                              <Select
                                options={accountoptions}
                                value={selectedAccount}
                                onChange={handleAccountSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/expense")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Expense
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default ExpenseUpdate;